import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_pav2jbzzry: FaireBrandEntity = {
  token: "b_pav2jbzzry",
  type: "brand",
  name: "Hours Haircare",
  avatarUrl:
    "https://cdn.faire.com/fastly/d5b1be78f659e2dddf62508dbce020403000edcea01895603c97641aba8a3f74.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/d0d201ef1124a3c96512a0aae9bbdab64b6baab2a24384f59373579d766891d6.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/d5b1be78f659e2dddf62508dbce020403000edcea01895603c97641aba8a3f74.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d0d201ef1124a3c96512a0aae9bbdab64b6baab2a24384f59373579d766891d6.jpeg",
  location: "Voorhees, NJ, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 2,
  isInsider: true,
  description:
    "Created by veteran hairstylist MariLynne Cosmillo, hOURS is a modern professional haircare brand that honors the precious time we spend on our hair. Each product in the hOURS line is designed to transform your styling routine—whether in the salon or at home—into quality experiences, through premium, luxury ingredients, results-driven formulas, and a rich, floral fragrance, to empower you for the day ahead.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:18.956Z",
    importedBy: "entity-db-cli",
  },
};
